import { createSelector } from '@ngrx/store';
import { selectPaymentsAndStatementsState } from '../reducers';
import * as fromIncludePaymentRun from '../reducers/include-payment-run.reducer';

export { IncludePaymentRunState } from '../reducers/include-payment-run.reducer';

export const selectIncludePaymentRunState = createSelector(
  selectPaymentsAndStatementsState,
  state => state[fromIncludePaymentRun.includePaymentRunFeatureKey]
);

export const selectIncludePaymentRunSuccess = createSelector(
  selectIncludePaymentRunState,
  (state) => state?.success
);

export const selectIncludePaymentRunFailure = createSelector(
  selectIncludePaymentRunState,
  (state) => state?.failure
);

export const selectIncludePaymentRunLoading = createSelector(
  selectIncludePaymentRunState,
  (state) => state?.loading
);
